import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ service }) => {
  return (
    <div className="bg-bg-light p-0 rounded-lg shadow-md border border-border-subtle hover:shadow-xl transition-shadow duration-300 overflow-hidden">
      {service.image && (
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-48 object-cover"
        />
      )}
      <div className="p-8">
        <h3 className="text-2xl font-semibold text-accent-red mb-4">{service.title}</h3>
        <p className="text-text-gray mb-4">{service.description}</p>
        <Link to={`/services/${service.slug}`} className="text-accent-red hover:underline">
          Learn More →
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;